"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Banner = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _Banner = require("./Banner.styled");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function createMarkup(html) {
  return {
    __html: html
  };
}
var Banner = exports.Banner = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var children = _ref.children,
    bannerStyle = _ref.bannerStyle,
    titleStyle = _ref.titleStyle,
    subTitleStyle = _ref.subTitleStyle,
    animation = _ref.animation,
    cameraPresenterId = _ref.cameraPresenterId;
  return /*#__PURE__*/_react["default"].createElement(_Banner.StyledBanner, (0, _extends2["default"])({
    id: "banner-".concat(cameraPresenterId),
    className: "dd-privacy-mask",
    dangerouslySetInnerHTML: createMarkup(children),
    bannerStyle: bannerStyle,
    titleStyle: titleStyle,
    subTitleStyle: subTitleStyle
  }, animation));
});
Banner.defaultProps = {
  cameraPresenterId: '',
  bannerStyle: {},
  titleStyle: {},
  subTitleStyle: {},
  animation: {}
};
Banner.propTypes = {
  cameraPresenterId: _propTypes.string,
  children: _propTypes.string.isRequired,
  bannerStyle: _propTypes.object,
  titleStyle: _propTypes.object,
  subTitleStyle: _propTypes.object,
  animation: (0, _propTypes.shape)({
    initial: _propTypes.object,
    animate: _propTypes.object,
    exit: _propTypes.object,
    transition: _propTypes.object
  })
};